module.exports = __webpack_public_path__ + "img/features_header_pos.55f652c2.png";